<h2 mat-dialog-title>Upload Scripts</h2>

<div *ngIf="showProgress" >
    <mat-progress-bar [mode] = "progressMode" mode="determinate" value="{{completeProgress}}"></mat-progress-bar>
    Uploading ({{currentProcessIndex + 1}} of {{totalProcessCount}})
    <br/> {{processingFileName}}
</div>
<div *ngIf="showOverwrite" >
    <mat-dialog-content class="saveDialog">
        <h3>{{processingFileName}} Already Exists</h3>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button  mat-button  class="mat-raised-button mat-primary" (click)="cancelProcess()">Cancel</button>&nbsp;&nbsp;
<!--        <button  mat-button  class="mat-raised-button mat-primary" (click)="skipFile()">Skip</button>&nbsp;&nbsp;-->
<!--        <button  mat-button  class="mat-raised-button mat-primary" (click)="overwriteFile('Current')">Replace</button>&nbsp;&nbsp;-->
<!--        <button  mat-button  class="mat-raised-button mat-primary" (click)="overwriteFile('All')">Replace All</button>-->
    </mat-dialog-actions>
</div>
<div *ngIf="showConfirm">
    <mat-dialog-content class="saveDialog">
        <h3 *ngIf="totalProcessCount !== 1">Upload {{totalProcessCount}} Files/Folders?</h3>
        <h3 *ngIf="totalProcessCount === 1">Upload {{processingFileName}}</h3>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button  mat-button class="mat-raised-button mat-secondary" mat-dialog-close>Cancel</button>&nbsp;&nbsp;
        <button  mat-button class="mat-raised-button mat-primary"  (click)="confirmSave()">Save</button>&nbsp;&nbsp;
    </mat-dialog-actions>
</div>
